import React from 'react';
import { Route } from 'react-router';

import VerifyCode from '../../components/Pages/VerifyCode/VerifyCodeForm';


const routes = <Route path="verifycode" component={VerifyCode} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/verifycode.js